// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_j5-a";
export var fulfillmentFormRail = "_j5-9";
export var headerTitleRow = "_j5-c";
export var orderDetailsWrapper = "_j5-7";
export var orderLinkTrigger = "_j5-2";
export var paymentInformationGrid = "_j5-h";
export var paymentSummaryColumn = "_j5-i";
export var shipmentContainer = "_j5-b";
export var shipmentDetailsMainPane = "_j5-8";
export var shipmentNavigationCard = "_j5-5";
export var shipmentNavigationRail = "_j5-3";
export var shipmentNavigationRailHeader = "_j5-4";
export var shipmentSummaryFact = "_j5-e";
export var shipmentSummaryGrid = "_j5-d";
export var shipmentSummaryMetadataRow = "_j5-f";
export var shipmentSummaryTags = "_j5-g";
export var shipmentWorkspace = "_j5-0";
export var shipmentWorkspaceContent = "_j5-6";
export var shipmentWorkspaceHeader = "_j5-1";